import React, { useContext } from 'react';
import { ConfigContext } from '../../providers/ConfigContext';
import { getDisplayImageUrl } from '../../utils/imageUtils';
import '../../styles/Loader.css';

const Loader = () => {
  const configCtx = useContext(ConfigContext);
  const brandName = configCtx?.config?.brand?.name || "L'ETÉ";
  const brandLogo = configCtx?.config?.brand?.logo;

  return (
    <div className="loader-overlay">
      <div className="loader-container">
        {brandLogo ? (
          <img
            src={getDisplayImageUrl(brandLogo)}
            alt={brandName}
            style={{
              maxHeight: '80px',
              maxWidth: '220px',
              objectFit: 'contain',
              animation: 'loaderPulse 1.5s ease-in-out infinite'
            }}
          />
        ) : (
          <div style={{
            fontFamily: 'var(--font-accent, "Playfair Display", serif)',
            fontSize: '1.6rem',
            fontWeight: 600,
            letterSpacing: '0.25em',
            textTransform: 'uppercase',
            color: '#ffffff',
            animation: 'loaderPulse 1.5s ease-in-out infinite'
          }}>
            {brandName}
          </div>
        )}
      </div>
      <style>{`
        @keyframes loaderPulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default Loader;
